import { Button, ButtonVariant, Intent, Tag, Tooltip } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { LANDING_EDIT_MODE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, useLandingConsoleStore,  } from "src/modules/pe-landing-module/data/store" 
import { setCursor } from "."
import inner_tool from "../../../../assets/img/inner-tool.svg"

/* Protopia Ecosystem component */
export interface IDragToolProps {
   
}
const InnerTool = (props: IDragToolProps): JSX.Element => {
    const editMode = useLandingConsoleStore((state: ILandingConsoleStore) => state.editMode)
    const setEdit = () => {
        useLandingConsoleStore.setState({ editMode: LANDING_EDIT_MODE.INNER })
        setCursor("default")
    }
    const isEdit = editMode === LANDING_EDIT_MODE.INNER
    return <Tooltip 
        content={ <div className="small letter-spacing-1 flex-centered">
            {__( "Inner edit" )}
            <Tag minimal className="ml-2 px-2 py-0"><div className="smallest text-light title">CTRL + I</div></Tag>
        </div> } 
        className=" ml-auto" 
        position="right"
        intent={ Intent.PRIMARY }
        compact
        hoverOpenDelay={ 600 }
        portalClassName="z-index-90"
        modifiers={{ 
            arrow: { enabled: true },
            flip: { enabled: true },
            preventOverflow: { enabled: false },
            offset: { 
                enabled: true, 
                options: {
                    offset: [0, 2],
                } 
            }, 
        }}
    >
        <Button variant={ isEdit ? ButtonVariant.SOLID : ButtonVariant.MINIMAL} onClick={ setEdit } >
            <div className={`d-flex flex-column align-items-center ${isEdit ? "" : "opacity_5"}`}>
                <img src={inner_tool} alt="" height={15} className="panel-icon" /> 
            </div>
        </Button>
    </Tooltip>
}
export default InnerTool